import { v4 as uuidV4 } from 'uuid';

export const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now
    .getDate()
    .toString()
    .padStart(2, '0');
  const currentDateString = `${year}-${month}-${day}`;

  return currentDateString;
};

export const getCurrentTime = () => {
  const now = new Date();
  const hours = now
    .getHours()
    .toString()
    .padStart(2, '0');
  const minutes = now
    .getMinutes()
    .toString()
    .padStart(2, '0');
  const currentTimeString = `${hours}:${minutes}`;

  return currentTimeString;
};

export const getNewTimeSlot = () => ({
  date: getCurrentDate(),
  time: getCurrentTime(),
  id: uuidV4(),
});

const teacherDetailsImportMapper = (teacherDetails = {}) => {
  const {
    teacher_id: id,
    teacher_name: name,
    cumulative_score: score,
    score_details: scoreDetails,
  } = teacherDetails ?? {};
  const {
    enrollments,
    sop_score: sopScore,
    student_density: studentDensity,
    plus_pac2paid: plusPacToPaid,
    base_pac2paid: basePacToPaid,
  } = scoreDetails?.score_data_l1 ?? {};

  return {
    id,
    name,
    score,
    enrollments: enrollments ?? '--',
    sopScore: sopScore ?? '--',
    studentDensity: studentDensity ?? '--',
    plusPacToPaid: plusPacToPaid ?? '--',
    basePacToPaid: basePacToPaid ?? '--',
  };
};

export const mappingResultImportMapper = (result = {}) => {
  const {
    id: mappingId,
    student_name: studentName,
    student_id: studentId,
    other_teachers: otherTeachers,
    best_teacher: bestTeacher,
    state,
  } = result ?? {};

  const mappedBestTeacher = teacherDetailsImportMapper?.(bestTeacher);
  const mappedOtherTeachers = otherTeachers?.map(teacher =>
    teacherDetailsImportMapper?.(teacher),
  );
  return {
    mappingId,
    studentName,
    studentId,
    otherTeachers: mappedOtherTeachers ?? [],
    bestTeacher: mappedBestTeacher,
    state,
  };
};
